"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _store = require("../../redux/store");
var _popupSlice = require("../../redux/popupSlice");
var _UpdateSubscription = _interopRequireDefault(require("../UpdateSubscription/UpdateSubscription"));
var _SwitchPlanPopup = _interopRequireDefault(require("../SwitchPlanPopup"));
var _PauseSubscriptionPopup = _interopRequireDefault(require("../PauseSubscriptionPopup"));
var _ResumeSubscriptionPopup = _interopRequireDefault(require("../ResumeSubscriptionPopup"));
var _CancelSwitchPopup = _interopRequireDefault(require("../CancelSwitchPopup"));
var _CancelPausePopup = _interopRequireDefault(require("../CancelPausePopup"));
var _jsxRuntime = require("react/jsx-runtime");
const PlanDetailsPopupManager = _ref => {
  let {
    customCancellationReasons,
    skipAvailableDowngradesStep,
    skipAvailableFreeExtensionStep,
    onCancel,
    onSwitchSuccess,
    onSwitchError
  } = _ref;
  const {
    isOpen,
    currentType
  } = (0, _store.useAppSelector)(_popupSlice.selectPopupDetails);
  if (!isOpen) return /*#__PURE__*/(0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {});
  switch (currentType) {
    case _popupSlice.POPUP_TYPES.UPDATE_SUBSCRIPTION_POPUP:
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(_UpdateSubscription.default, {
        customCancellationReasons: customCancellationReasons,
        skipAvailableDowngradesStep: skipAvailableDowngradesStep,
        skipAvailableFreeExtensionStep: skipAvailableFreeExtensionStep
      });
    case _popupSlice.POPUP_TYPES.SWITCH_PLAN_POPUP:
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(_SwitchPlanPopup.default, {
        onCancel: onCancel,
        onSwitchSuccess: onSwitchSuccess,
        onSwitchError: onSwitchError
      });
    case _popupSlice.POPUP_TYPES.PAUSE_SUBSCRIPTION_POPUP:
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(_PauseSubscriptionPopup.default, {});
    case _popupSlice.POPUP_TYPES.RESUME_SUBSCRIPTION_POPUP:
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(_ResumeSubscriptionPopup.default, {});
    case _popupSlice.POPUP_TYPES.CANCEL_SWITCH_POPUP:
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(_CancelSwitchPopup.default, {});
    case _popupSlice.POPUP_TYPES.CANCEL_PAUSE_POPUP:
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(_CancelPausePopup.default, {});
    default:
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {});
  }
};
var _default = exports.default = PlanDetailsPopupManager;